/**
 * Theme v2 — elevation tokens.
 *
 * Three semantic levels:
 *   elev1 — resting cards, inputs (matches prototype's `boxShadow`)
 *   elev2 — popovers, dropdowns, floating action buttons
 *           (matches prototype's `boxShadowSecondary`)
 *   elev3 — modals, drawers (new — prototype mixes per-modal shadows)
 *
 * Picking a level by intent (`elev2` = "this floats") rather than by
 * pixel offset keeps the design language consistent.
 */
export const shadows = {
  none: "none",
  elev1: "0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)",
  elev2: "0 4px 12px rgba(0,0,0,0.08)",
  elev3: "0 8px 40px rgba(0,0,0,0.18), 0 2px 8px rgba(0,0,0,0.06)",

  // Accent-tinted glow for primary CTAs on hover. Subtle — designed to
  // reinforce the brand on the focus path, not steal attention.
  accentGlow: "0 4px 12px rgba(20, 184, 166, 0.20)",

  // Sideways shadow the experience-page sidebar casts onto the document.
  // Split from the offset because its sign depends on which side the
  // sidebar is on.
  sidebarBlur: "24px",
  sidebarColor: "rgba(0, 0, 0, 0.10)",
} as const;

export type Shadows = typeof shadows;
